import '../styles/index.scss';

import { graphql } from 'gatsby';
import { PropTypes } from 'prop-types';
import React from 'react';

import ArticleHeroImage from '../components/Article/ArticleHeroImage';
import ArticleRender from '../components/Article/ArticleRender';
import Footer from '../components/Footer/Footer';
import Header from '../components/Header';
import Metadata from '../components/Metadata';

const AboutUs = ({ data, location }) => {
  const {
    contentfulAbout: { aboutBody, coverImage, heroText, metadata },
  } = data;

  return (
    <>
      <Metadata data={metadata} location={location} />
      <div>
        <Header />
        <ArticleHeroImage article={false} image={coverImage} text={heroText} />
        <div className="article about" data-module-id="article_about">
          {aboutBody.map((item) => ArticleRender(item))}
          <blockquote>
            Work better.
            <br />
            Live smarter.
            <br />
            Be happier.
          </blockquote>
        </div>
      </div>
      <Footer />
    </>
  );
};

AboutUs.propTypes = {
  data: PropTypes.object,
  location: PropTypes.object,
};

export const query = graphql`
  query {
    contentfulAbout {
      heroText {
        raw
      }
      coverImage {
        ...ContentfulBaseImageFragment
      }
      metadata {
        ...ContentfulMetadataFragment
      }
      aboutBody {
        ... on Node {
          ...ContentfulAllArticleComponentsFragment
        }
        ... on Node {
          ... on ContentfulEventsPlaceholder {
            ...ContentfulEventsPlaceholderFragment
          }
          ... on ContentfulProductHighlight {
            ...ContentfulProductHighlightFragment
          }
        }
      }
    }
  }
`;

export default AboutUs;
